import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerLeftDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowCornerLeftDown"><Path fillRule="evenodd" clipRule="evenodd" d="M20.4142 5H10.4142V17.5858L13.4142 14.5858L14.8284 16L9.41421 21.4142L4 16L5.41421 14.5858L8.41421 17.5858V3H20.4142V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerLeftDown;
